import { render, staticRenderFns } from "./PxCamposCompraProdutosViewUseallSetup.vue?vue&type=template&id=c30fb544&"
import script from "./PxCamposCompraProdutosViewUseallSetup.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraProdutosViewUseallSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports